// ======================================================================
// File Name       : ServiceNoticeUserSearchDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { reduxForm, isInvalid } from 'redux-form';
import { connect } from 'react-redux';
import { Form, Col, Button, Row } from 'react-bootstrap';
import RenderField from '../../../utils/ReduxFormUtils';
import ReduxFormPaging from '../../ReduxFormPaging';
import { SERVICE_USER_TYPE } from '../../../constants/ServiceConstant';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../../constants/UserAttributeConstants';
import CustomButton from '../../button/CustomButton';

class ServiceNoticeUserSearchDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.onSearchBtnClick = this.onSearchBtnClick.bind(this);
  }

  onSearchBtnClick() {
    const { invalid } = this.props;
    if (invalid) return;
    this.props.change('startPosition', 0);
    this.props.onSearchBtnClick(0);
  }

  render() {
    const {
      invalid,
      getStartEndData,
      recordNum,
      userType,
      managementAuthoritySecernId,
      authorityInfo,
      userAttributeKeyNum,
      checkUncheckAllUsersOnPage,
    } = this.props;
    let managementAuthorityList = [];
    const managementAuthorityListFirst = [
      {
        managementAuthoritySecernId: '',
        managementAuthorityName: '',
      },
    ];
    if (authorityInfo && authorityInfo.managementAuthorityList) {
      managementAuthorityList = managementAuthorityListFirst.concat(authorityInfo.managementAuthorityList);
    }
    return (
      <div>
        <Form onSubmit={this.props.handleSubmit} className='form-horizontal'>
          <Row>
          <Form.Group>
            <Col as={Form.Label} sm={3} className="text-left">
              ユーザー名
            </Col>
            <Col sm={7}>
              <RenderField type="text" name="userName" />
            </Col>
          </Form.Group>
          </Row>
          <Row>
          <Form.Group>
            <Col as={Form.Label} sm={3} className="text-left">
              ログインID
            </Col>
            <Col sm={7}>
              <RenderField type="text" name="loginId" />
            </Col>
          </Form.Group>
          </Row>
          <Row>
          <Form.Group>
            <Col sm={12} className="text-center margin-bottom-20">
              {/* <Button
                onClick={this.props.handleSubmit(this.onSearchBtnClick)}
                bsStyle="primary"
                className="btn-96"
              >
                search
              </Button> */}
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                handleClick={this.props.handleSubmit(this.onSearchBtnClick)}
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
          </Row>
          <Row className="align-items-center">
            <Col sm={6} className="d-flex align-items-center">
              <Button
                variant="default"
                onClick={checkUncheckAllUsersOnPage}
                className="btn-96"
                style={{ marginBottom: '10px' }}
              >
                全選択/解除
              </Button>
            </Col>

            <Col sm={6} className="d-flex justify-content-center margin-bottom-10">
              <ReduxFormPaging
                type="paging"
                name="startPosition"
                recordNum={recordNum}
                getStartEndData={getStartEndData}
                invalid={invalid}
              />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceNoticeRegisterForm, searchUserForm } = state.form;
  const { authorityInfo } = state.authority;
  const initialValues = {
    userAttributeKeyNum: 1,
  };
  if (
    authorityInfo &&
    authorityInfo.managementAuthorityList &&
    authorityInfo.managementAuthorityList.length
  ) {
    initialValues.managementAuthoritySecernId = '';
  }
  return {
    searchUserForm,
    serviceNoticeRegisterForm,
    invalid: isInvalid('searchServiceUserForm')(state),
    initialValues,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'searchServiceUserForm',
    touchOnChange: true,
    enableReinitialize: true,
  })(ServiceNoticeUserSearchDialog),
);
